/**
 * 组织/门店树接口 — feifan-xxl-art /organization/tree
 */

import { request } from '@/services/http';
import { portalRequest } from '@/services/portalHttp';

export const organizationService = {
  /**
   * GET /organization/tree
   * @param {{ tenantId?: number|string }} params
   */
  getTree: async (params = {}) => {
    const tenantId = params.tenantId != null && params.tenantId !== ''
      ? Number(params.tenantId) || params.tenantId
      : 1;

    try {
      // 优先调用 feifan-xxl-art 网关路由
      return await request('/organization/tree', {
        method: 'GET',
        params: { tenantId },
      });
    } catch (err) {
      // 若 art 网关未路由则回退至 alert/portal 网关路由
      return await portalRequest('/organization/tree', {
        method: 'GET',
        params: { tenantId },
      });
    }
  },
};
